import * as tConst from "../../../common/Constants";

function prepareTicket(item, GroupTitle = "", Color = "", AdditionalPlanningPriority = 0) {
    item.Project = item.fields[tConst.AF_PROJECT];
    if (Color !== "") {
        item.Color = Color;
    }
    item.comment = "Processes by prepareTicket";
    const pp = item.fields[tConst.AF_PLANNING_PRIORITY]
    const _pp = ((pp) ? 1 * pp : 99999) + AdditionalPlanningPriority
    console.log("2025-01-03 - prepareTicket", item.fields[tConst.AF_PLANNING_PRIORITY], pp, _pp, AdditionalPlanningPriority)
    item.planningPri = _pp
    const _assignee = item.fields[tConst.AF_ASSIGNED_TO] ? item.fields[tConst.AF_ASSIGNED_TO].displayName : tConst.ADO_UNASSIGNED;
    item.Assignee = _assignee;
    const _initiative = item.fields[tConst.AF_INITIATIV] ? item.fields[tConst.AF_INITIATIV] : "..";
    item.Initiative = _initiative;
    item.Guestimate = item.fields[tConst.AF_GUESTIMATE];

    const teamNames = tConst.TEAMS_LIST.map(item => item.team)

    const _teams = item.fields[tConst.AF_TEAMS]?.split(";")
        .filter(item => {
            // Filter to make sure we only return valid teams :-) 
            return teamNames.indexOf(item) >-1
        });
    
    item.Teams = (_teams ? _teams : [])

    if (GroupTitle !== "") {
        item.GroupBy = GroupTitle;
    }

    const _start = new Date(item.fields[tConst.AF_START_ITERATION]);
    const _end = new Date(item.fields[tConst.AF_END_ITERATION]);
    const _LengthSeconds = (_end - _start) / 1000;
    const _LengthDays = _LengthSeconds / (3600 * 24);
    const _LengthSprints = Math.ceil(_LengthDays / 14);

    item.Length = _LengthSprints;
    

    return item;
}

export function prepareTickets(items, setAssigneeList, setInitiativeList) {

    const _assigneeList = items.map((item) => item.Assignee).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a.localeCompare(b)).map((item) => { return { label: item, value: item } });
    setAssigneeList(_assigneeList);

    const _initiaitveList2 = items.sort((a, b) => { return a.planningPri - b.planningPri })
    const _initiaitveList3 = _initiaitveList2.map((item) => { return { Initiative: item.Initiative, planningPri: item.planningPri } });
    const _initiaitveList4 = _initiaitveList3.filter((value, index, self) => self.findIndex(t => t.Initiative === value.Initiative) === index)
    const _initiaitveList5 = _initiaitveList4.map((item) => { return { label: item.Initiative, value: item.Initiative } });

    // .filter((value, index, self) => self.indexOf(value) === index).map((item) => {return {label: item, value: item}});
    // const _initiaitveList2 = items.map((item) => item.Initiative).filter((value, index, self) => self.indexOf(value) === index).map((item) => {return {label: item, value: item}});

    const _initiaitveList = items.map((item) => item.Initiative).filter((value, index, self) => self.indexOf(value) === index).map((item) => { return { label: item, value: item } });
    setInitiativeList(_initiaitveList5);
    return { _assigneeList, _initiaitveList }


}

export default prepareTicket;